<template>
    <div class="container">
      <form @submit.prevent="submitRequest">
        <div class="form-row">
          <div class="form-group col-md-12">
            <label>Name</label>
            <input
                type="text"
                class="form-control"
                v-model="form.name"
                name="name" readonly
                placeholder="Your Name">
          </div>
        </div>
        <div class="form-row">
          <b-form-group
              label="Account Number:"
              class="form-group col-md-12"
              label-for="accountnumber"
          >
            <b-form-select
                id="accountnumber"
                 class="form-control"
                v-model="form.account"
                :options="account.accountoption"
                required
            >
            </b-form-select>
          </b-form-group>
        </div>
        <div class="form-row">
          <div class="form-group col-md-12">
          <label>Email</label>
          <input
              type="email"
              class="form-control"
              v-model="form.email"
              name="email" readonly
              placeholder="Your Email"
          >
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-md-12">
          <label>Message</label>
          <textarea
              name="message"
              class="form-control"
              v-model="form.message"
              cols="30" rows="5"
              placeholder="Message">
          </textarea>
          </div>
        </div>

        <button type="submit" class="btn btn-outline-primary btn-sm" :disabled="this.admin.supportloading">
          <span v-if="this.admin.supportloading" class="spinner-grow spinner-grow-sm mr-4"></span> Submit Message
        </button>
      </form>
    </div>

</template>

<script>
import {mapState } from 'vuex'

export default {
  name: "CustomerSupportForm",
  data() {
    return {
      form: {}
    }
  },
  methods: {
    submitRequest: async function () {
      this.form.accountNumber = this.form.account.accountnumber
      let result = await this.$store.dispatch("admin/submitSupportIssues", this.form, {root: false});
      this.form.message = ''
      this.auth.message = ''
      this.$swal({
        title: result.responsecode === '00' ? 'Success' : 'Warning',
        text: 'message successfully sent',
        icon: result.responsecode === '00' ? 'success' : 'warning',
        showCancelButton: false,
        confirmButtonText: 'Ok'
      });
    }
  },
  mounted() {
    this.form = this.auth
  },
  computed: {
    ...mapState(['auth', 'account', 'admin'])
  }
}
</script>

<style scoped>

</style>
